import { Component, OnDestroy, OnInit } from "@angular/core";
import { NbMenuItem, NbIconLibraries } from "@nebular/theme";

import { GeneralService } from "../../../@core/data/general.service";

@Component({
  selector: "edm-footer-menu",
  styleUrls: ["./footer-menu.component.scss"],
  templateUrl: "./footer-menu.component.html",
  standalone: false,
})
export class FooterMenuComponent implements OnInit, OnDestroy {

  menu: NbMenuItem[] = [];

  constructor(
    iconsLibrary: NbIconLibraries,
    private generalService: GeneralService
  ) {
    iconsLibrary.registerFontPack("font-awesome", { packClass: "fas" });
    iconsLibrary.setDefaultPack("font-awesome");
    this.generalService.home$.subscribe((home) => {
      this.loadMenu();
    });
    this.loadMenu();
  }

  loadMenu(): void {
    this.menu = this.generalService.mobileMenu();
  }

  ngOnInit(): void {

  }



  ngOnDestroy(): void {

  }

}
